import {useGetInfiniteTeams} from '@/features/treatment-requests/teams/queries/useGetInfiniteTeams'
import {useInputSearch} from '@/hooks/useInputSearch'
import {ResponseType} from '@/types'
import {useMemo} from 'react'

export const useTeamSearchableList = ({
    treatmentRequestId,
    responseType,
    limit = 10,
    enabled,
    search,
    projectId
}: {
    treatmentRequestId: string
    responseType: ResponseType
    limit?: number
    enabled?: boolean
    search?: string
    projectId?: string
}) => {
    const searchControls = useInputSearch(search)
    const query = useGetInfiniteTeams({
        urlParams: {treatmentRequestId},
        params: {search: searchControls.searchValue, responseType, limit, page: 1, projectId},
        options: {enabled}
    })

    const teamMembers = useMemo(() => query.data?.pages.flatMap(page => page.data) ?? [], [query.data])

    return {
        ...query,
        ...searchControls,
        teamMembers
    }
}
